import React, { useState, useEffect, useCallback } from "react";
import Box from "@mui/material/Box";
import TopHeader from "../../Component/Header/TopHeader";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@material-ui/core/IconButton";
import { selectCurrentScope, selectUserId } from "../../app/auth/authSlice";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Tooltip from "@material-ui/core/Tooltip";
import { useSelector } from "react-redux";
import Spinner from "../../Component/spinner/spinner";
import "./journalTabel.css";
import { useCreateEventMutation, useGetEventBasedOnFilterMutation, useLazyGetEventByIdQuery } from "../../app/services/eventService";
import GetChapterName from "../../Component/HomePage/GetChapterName";
import GetSIGName from "../../Component/HomePage/GetSigName";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import { useLazyGetAllGalleryQuery } from "../../app/services/galleryService";
import { toast } from "react-toastify";
import { FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { Editor } from "primereact/editor";
import { selectCurrentChapterAdmin } from "../../app/features/chapterAdminSlice";
import { selectCurrentSig } from "../../app/features/sigSlice";
import NoteAddIcon from '@mui/icons-material/NoteAdd';

//table head for News
function EnhancedNewsTableHead() {
  const headCells = [
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      label: "Title",
    },
    {
      id: "description",
      numeric: false,
      disablePadding: true,
      label: "Description",
    },
    {
      id: "date",
      numeric: false,
      disablePadding: true,
      label: "Date",
    },
    {
      id: "createdBy",
      numeric: false,
      disablePadding: true,
      label: "Created by",
    },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions", width: '300px' },
  ];

  return (
    <>
      <TableHead>
        <TableRow className="menus-color">
          {headCells.map((headCell) => (
            <TableCell
              sx={{ textAlign: "center", color: "#ffff", width: headCell?.width ? headCell.width : 'auto' }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

function JournalTable() {
  const [loading, setLoading] = useState(true);
  const memberScope = useSelector(selectCurrentScope);
  const createdBy = useSelector(selectUserId);
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [getPastEvents] = useGetEventBasedOnFilterMutation();
  const navigate = useNavigate();
  const [allNews, setAllNews] = useState([]);
  const [getAllGallery] = useLazyGetAllGalleryQuery();
  const userId = useSelector(selectCurrentChapterAdmin);
  const sigDetails = useSelector(selectCurrentSig)
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [error, setError] = useState("");

  const [updateEvent] = useCreateEventMutation();
  const [getEventById] = useLazyGetEventByIdQuery();
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [reportContent, setReportContent] = useState("");
  const [reportError, setReportError] = useState("");

  const CATEGORY_NAMES = {
    0: "School Teachers",
    1: "College Teachers",
    2: "Research Scholars",
    3: "UG/PG Students",
    4: "School Students",
    5: "Others",
    6: "Grand Total"
  };

  const initialStats = [
    { category: 0, male: 0, female: 0, total: 0 },
    { category: 1, male: 0, female: 0, total: 0 },
    { category: 2, male: 0, female: 0, total: 0 },
    { category: 3, male: 0, female: 0, total: 0 },
    { category: 4, male: 0, female: 0, total: 0 },
    { category: 5, male: 0, female: 0, total: 0 }
  ];
  const [participationStatistics, setParticipationStatistics] = useState(initialStats);

  const handleStatChange = (index, field, value) => {
    const numValue = value === "" ? "" : parseInt(value, 10) || 0;

    const updated = participationStatistics.map((item, i) => {
      if (i !== index) return item;

      const updatedItem = {
        ...item,
        [field]: numValue,
      };

      updatedItem.total =
        (Number(updatedItem.male) || 0) +
        (Number(updatedItem.female) || 0);

      return updatedItem;
    });

    setParticipationStatistics(updated);
  };

  const handleKeyDown = (e) => {
    if (["-", "+", "e", "E", "."].includes(e.key)) {
      e.preventDefault();
    }
  };

  const grandTotalMale = participationStatistics.reduce((acc, curr) => acc + (parseInt(curr.male) || 0), 0);
  const grandTotalFemale = participationStatistics.reduce((acc, curr) => acc + (parseInt(curr.female) || 0), 0);
  const grandTotalTotal = participationStatistics.reduce((acc, curr) => acc + (parseInt(curr.total) || 0), 0);

  const handleOpenReportModal = (event) => {
    getEventById(event._id).then(res => {
      if (res?.data?.status || res?.data?.data) {
        const fullEvent = res.data.data;
        setSelectedEvent(fullEvent);
        setReportContent(fullEvent?.report || "");
        setParticipationStatistics(fullEvent?.participationStatistics?.length ? fullEvent.participationStatistics.filter(s => s.category !== 6 && s.category !== '6') : initialStats);
      } else {
        setSelectedEvent(event);
        setReportContent(event?.report || "");
        setParticipationStatistics(event?.participationStatistics?.length ? event.participationStatistics.filter(s => s.category !== 6 && s.category !== '6') : initialStats);
      }
    }).catch(() => {
      setSelectedEvent(event);
      setReportContent(event?.report || "");
      setParticipationStatistics(event?.participationStatistics?.length ? event.participationStatistics.filter(s => s.category !== 6 && s.category !== '6') : initialStats);
    });
    setReportError("");
    setReportModalOpen(true);
  };

  const handleCloseReportModal = () => {
    setReportModalOpen(false);
    setSelectedEvent(null);
    setReportContent("");
    setReportError("");
    setParticipationStatistics(initialStats);
  };
  function convertToFormData(rawData) {
    const formData = new FormData();
    Object.entries(rawData).forEach(([key, value]) => {
      if (value instanceof File) {
        formData.append(key, value);
      } else if (value instanceof Object && key !== "jointOrganisers" &&
        key !== "sponsors" &&
        key !== "speakers" &&
        key !== "contacts" &&
        key !== "participationStatistics") {
        // If it's a nested object, iterate through its properties
        Object.keys(value).forEach(subKey => {
          formData.append(`${key}.${subKey}`, value[subKey]);
        });
      }
      else if (
        key !== "jointOrganisers" &&
        key !== "sponsors" &&
        key !== "speakers" &&
        key !== "contacts" &&
        key !== "participationStatistics"
      ) {
        const filterFileKeys = ["flyerFile", "brouchureFile", "scheduleFile", "readingMaterialFile", "image"];
        if (!filterFileKeys.includes(key)) {
          formData.append(key, value);
        }
      }
    });

    // Handle nested jointOrganisers array
    if (rawData.jointOrganisers && Array.isArray(rawData.jointOrganisers)) {
      rawData.jointOrganisers.forEach((item, index) => {
        Object.entries(item).forEach(([subKey, subValue]) => {
          const filterFileKeys = ["nonMemberLogoImage", "institutionLogoImage"];
          if (!filterFileKeys.includes(subKey)) {
            if (subValue instanceof File) {
              formData.append(`jointOrganisers[${index}].${subKey}`, subValue ? subValue : '');
            } else {
              formData.append(`jointOrganisers[${index}].${subKey}`, subValue ? subValue : '');
            }
          }
        });
      });
    }
    // Handle nested sponsors array
    if (rawData.sponsors && Array.isArray(rawData.sponsors)) {
      rawData.sponsors.forEach((item, index) => {
        Object.entries(item).forEach(([subKey, subValue]) => {
          const filterFileKeys = ["nonMemberLogoImage", "institutionLogoImage"];
          if (!filterFileKeys.includes(subKey)) {
            if (subValue instanceof File) {
              formData.append(`sponsors[${index}].${subKey}`, subValue ? subValue : '');
            } else {
              formData.append(`sponsors[${index}].${subKey}`, subValue ? subValue : '');
            }
          }
        });
      });
    }
    // Handle nested speakers array
    if (rawData.speakers && Array.isArray(rawData.speakers)) {
      rawData.speakers.forEach((item, index) => {
        Object.entries(item).forEach(([subKey, subValue]) => {
          const filterFileKeys = ["photoImage",];
          if (!filterFileKeys.includes(subKey)) {
            if (subValue instanceof File) {
              formData.append(`speakers[${index}].${subKey}`, subValue ? subValue : '');
            } else {
              formData.append(`speakers[${index}].${subKey}`, subValue ? subValue : '');
            }
          }
        });
      });
    }
    // Handle nested contacts array
    if (rawData.contacts && Array.isArray(rawData.contacts)) {
      rawData.contacts.forEach((item, index) => {
        Object.entries(item).forEach(([subKey, subValue]) => {
          if (subValue instanceof File) {
            formData.append(`contacts[${index}].${subKey}`, subValue ? subValue : '');
          } else {
            formData.append(`contacts[${index}].${subKey}`, subValue ? subValue : '');
          }
        });
      });
    }
    // Handle nested participationStatistics array
    if (rawData.participationStatistics && Array.isArray(rawData.participationStatistics)) {
      rawData.participationStatistics.forEach((item, index) => {
        Object.entries(item).forEach(([subKey, subValue]) => {
          formData.append(`participationStatistics[${index}].${subKey}`, subValue !== undefined && subValue !== null ? subValue : '');
        });
      });
    }
    return formData;
  }

  const handleSubmitReport = () => {
    const strippedContent = (reportContent || "").replace(/(<([^>]+)>)/gi, "").trim();
    if (!strippedContent) {
      setReportError("Report is required");
      return;
    }
    if (strippedContent.length < 10) {
      setReportError("Report must be at least 10 characters long");
      return;
    }

    const payloadStats = [...participationStatistics, {
      category: 6,
      totalMaleCount: grandTotalMale,
      totalFemaleCount: grandTotalFemale,
      grandTotal: grandTotalTotal
    }];

    let payload = {
      ...selectedEvent,
      id: selectedEvent._id,
      report: reportContent,
      participationStatistics: payloadStats
    }
    const formData = convertToFormData(payload)
    formData.id = selectedEvent._id; // Add id property directly to formData object for RTK query url builder
    updateEvent(formData).then((res) => {
      if (res?.data?.status || res?.data?.success || res?.data) {
        toast.success("Report updated successfully");
        handleCloseReportModal();
        fetchData();
      } else {
        toast.error(res?.error?.data?.message || "Failed to update report");
      }
    }).catch(err => {
      toast.error("Failed to update report");
    })
  };

  //Based on memberscope
  const getLinkPath = (event) => {
    switch (memberScope) {
      case "PORTAL_SUPER_ADMIN":
        return "/admin/add-edit-Gallery?category=" + event?.title.split(' ').join('_')
      case "PORTAL_ADMIN":
        return "/assistantAdmin/add-edit-Gallery?category=" + event?.title.split(' ').join('_')
      case "PORTAL_SIG_ADMIN":
        return "/sigAdmin/add-edit-Gallery?category=" + event?.title.split(' ').join('_')
      case "PORTAL_CHAPTER_ADMIN":
        return "/chapterAdmin/add-edit-Gallery?category=" + event?.title.split(' ').join('_')
      default:
        return "";
    }
  };
  //Based on memberscope
  const routeToGallery = (event) => {
    let galleryId = '';
    getAllGallery().then(res => {
      const gallery = res?.data?.data.filter(item => item?.category === event.title);
      if (gallery.length > 0) { // Check if gallery has any items
        galleryId = gallery[0]._id; // Access the _id of the first item in the gallery
        if (galleryId) {
          switch (memberScope) {
            case "PORTAL_SUPER_ADMIN":
              navigate("/admin/showGallery/" + galleryId);
              break;
            case "PORTAL_ADMIN":
              navigate("/assistantAdmin/showGallery/" + galleryId);
              break;
            case "PORTAL_SIG_ADMIN":
              navigate("/sigAdmin/showGallery/" + galleryId);
              break;
            case "PORTAL_CHAPTER_ADMIN":
              navigate("/chapterAdmin/showGallery/" + galleryId);
              break;
            default:
              return "";
          }
        }
      } else {
        toast.error('No Gallery images on this event');
      }
    });
  };
  //getAllPendingEventList
  const fetchData = useCallback(() => {
    var data = {
      filter: 0, //Past Event
      page: page + 1,
      itemsPerPage: itemsPerPage,
      isApproved: 1,
      isEnable: 0,
      scope: memberScope ?? '',
      createdById: createdBy ?? ''
    };
    getPastEvents(data)
      .then((res) => {
        setLoading(false);
        setAllNews(res?.data?.data?.eventDetails || []);
        setTotalPage(res?.data?.data.totalCount || 0);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, [getPastEvents, memberScope, page, itemsPerPage, createdBy])

  //calling event data
  useEffect(() => {
    fetchData(); // Fetch data on component mount
  }, [fetchData]); // Update useEffect dependencies

  //page Click for News
  const handleNewsPageClick = ({ selected }) => {
    setSearchTerm('')
    setError("");
    setPage(selected);
  };


  //calculate pagecount
  const pageCount = Math.ceil(totalPage / itemsPerPage);

  const handlePageChange = () => {
    const pageNumber = Number(searchTerm);
    if (isNaN(pageNumber) || pageNumber < 0) {
      setError("Page number cannot be less than 1");
    } else if (pageNumber > pageCount) {
      setError("Please enter valid page number");
    } else if (pageNumber === 0) {
      setError("Please enter page number");
    } else {
      setError("");
      setPage(pageNumber - 1);
    }
  };

  return (
    <>
      <TopHeader />
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">Our Updates</h2>
        </div>
      </div>
      <div className=' p-md-5 p-3 overallPadding'>
        {loading ? (
          <Spinner />
        ) : (
          <Box>
            <TableContainer component={Paper} sx={{ boxShadow: 0 }} className="rounded-0">
              <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                <EnhancedNewsTableHead />
                <TableBody>
                  {allNews.length > 0 ? (
                    allNews.map((event, index) => (
                      <TableRow
                        hover
                        key={event._id}
                        sx={{
                          cursor: "pointer",
                          backgroundColor:
                            index % 2 === 0 ? "#f0f0f0" : "white",
                        }}
                      >
                        <TableCell align="center">{event.title}</TableCell>
                        <TableCell width={220} align="center">
                          <p style={{ textAlign: 'justify' }} className="text-black">
                            {event?.description ? (event.description.replace(/<[^>]+>/g, "").length > 25 ? event.description.replace(/<[^>]+>/g, "").slice(0, 25) + "..." : event.description.replace(/<[^>]+>/g, "")) : ""}
                          </p>
                        </TableCell>
                        <TableCell align="center">
                          {new Date(event.startDate).toLocaleDateString(
                            "en-In",
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            }
                          )}
                          {event.endDate ? (
                            <>
                              <br></br>to <br />
                            </>
                          ) : (
                            ""
                          )}
                          {event.endDate
                            ? new Date(event.endDate).toLocaleDateString(
                              "en-In",
                              {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                              }
                            )
                            : ""}
                        </TableCell>
                        <TableCell align="center" >
                          {event?.createdBy?.role === "PORTAL_SUPER_ADMIN" ||
                            event?.createdBy?.role === "PORTAL_ADMIN" ? (
                            "ELTAI"
                          ) : event?.createdBy?.role ===
                            "PORTAL_CHAPTER_ADMIN" ? (
                            <GetChapterName id={event?.createdBy?.id} />
                          ) : (
                            <GetSIGName id={event?.createdBy?.id} />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {(event.isDeleted !== 2 && (memberScope === 'PORTAL_SUPER_ADMIN' || memberScope === 'PORTAL_ADMIN' || (event?.chaptersId && event?.chaptersId.includes(userId?._id)) || (event?.sigGroupsId && event?.sigGroupsId.includes(sigDetails?._id)))) && (
                            <Tooltip title={event?.report ? "View & Edit Report" : "Add Report"}>
                              <IconButton
                                aria-label={event?.report ? "View & Edit Report" : "Add Report"}
                                onClick={() => handleOpenReportModal(event)}
                              >
                                <NoteAddIcon className={event?.report ? "text-success" : ""} />
                              </IconButton>
                            </Tooltip>
                          )}
                          {(event.isDeleted !== 2 && (memberScope === 'PORTAL_SUPER_ADMIN' || memberScope === 'PORTAL_ADMIN' || (event?.chaptersId && event?.chaptersId.includes(userId?._id)) || (event?.sigGroupsId && event?.sigGroupsId.includes(sigDetails?._id)))) && (
                            <Tooltip title="Add Album">
                              <IconButton
                                aria-label="Add Album"
                                onClick={() =>
                                  navigate(getLinkPath(event))
                                }
                              >
                                <AddPhotoAlternateIcon className="icon-vieweye-color" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {!(event.isDeleted === 2) && (
                            <Tooltip title="View Album">
                              <IconButton
                                aria-label="view"
                                onClick={() => {
                                  routeToGallery(event)
                                }
                                }
                              >
                                <PhotoLibraryIcon className="text-success" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <>
                      <TableRow>
                        <TableCell colSpan={5}>
                          <p className="text-black text-center">
                            Will Be Added Shortly
                          </p>
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {allNews.length > 0 ? (
              <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                <div className="mb-2 mb-md-0">
                  <div className="d-flex gap-2">
                    <input
                      type="number"
                      min={1}
                      placeholder="Page no."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="search-input"
                    />
                    <div className="goPage cursor-pointer" onClick={handlePageChange}>
                      <h5 className="p-2 m-0">Go</h5>
                    </div>
                  </div>
                  {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                </div>

                {/* Pagination in the Center */}
                <div className="my-3 my-md-0">
                  <ReactPaginate
                    pageCount={pageCount} // Calculate total pages
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={1}
                    onPageChange={handleNewsPageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    disabledClassName={"disablebtn"}
                    previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                    nextLabel={pageCount > 1 && page + 1 !== pageCount ? "Next" : null}
                    forcePage={page}
                  />
                </div>
                <div className="mb-2 mb-md-0">
                  <FormControl variant="outlined">
                    <InputLabel></InputLabel>
                    <Select
                      className="itemsperpage"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const value = e.target.value;
                        setItemsPerPage(value);
                        setError('');
                        setSearchTerm('');
                        setPage(0);
                      }}
                      MenuProps={{
                        MenuListProps: {
                          sx: {
                            display: 'flex',
                            flexDirection: 'column',
                          },
                        },
                      }}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>

                  </FormControl>
                </div>
              </div>
            ) : (<></>)}
          </Box>
        )}
      </div >
      <Dialog open={reportModalOpen} onClose={handleCloseReportModal} maxWidth="md" fullWidth>
        <DialogTitle>{reportContent ? "Edit Report" : "Add Report"}</DialogTitle>
        <DialogContent>
          <div className="mt-3">
            <Editor
              value={reportContent}
              onTextChange={(e) => {
                setReportContent(e.htmlValue)
                if (e.htmlValue) setReportError("");
              }}
              headerTemplate={
                <span className="ql-formats">
                  <select className="ql-header" aria-label="Header" />
                  <button className="ql-bold" aria-label="Bold" />
                  <button className="ql-italic" aria-label="Italic" />
                  <button className="ql-underline" aria-label="Underline" />
                  <button className="ql-strike" aria-label="Strike" />
                  <select className="ql-align" value="" aria-label="Align" />
                  <button className="ql-list" value="ordered" aria-label="Ordered List" />
                  <button className="ql-list" value="bullet" aria-label="Unordered List" />
                  <select className="ql-color" />
                  <select className="ql-background" />
                  <button className="ql-clean" aria-label="Clear Formatting" />
                </span>
              }
              style={{ height: '250px' }}
            />
            {reportError && <p className="text-danger mt-1">{reportError}</p>}
          </div>
          <div className="mt-4">
            <h5 className="fw-bold mb-3">Participant Details</h5>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Category</th>
                    <th>Male</th>
                    <th>Female</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {participationStatistics.map((stat, index) => (
                    <tr key={index}>
                      <td className="align-middle">{CATEGORY_NAMES[stat.category] || stat.category}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={stat.male}
                          min="0"
                          onKeyDown={handleKeyDown}
                          onChange={(e) => handleStatChange(index, 'male', e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={stat.female}
                          min="0"
                          onKeyDown={handleKeyDown}
                          onChange={(e) => handleStatChange(index, 'female', e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={stat.total}
                          min="0"
                          onChange={(e) => handleStatChange(index, 'total', e.target.value)}
                          disabled
                        />
                      </td>
                    </tr>
                  ))}
                  <tr className="table-light fw-bold">
                    <td>Grand Total</td>
                    <td>{grandTotalMale}</td>
                    <td>{grandTotalFemale}</td>
                    <td>{grandTotalTotal}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseReportModal}
            variant="outlined"
            color='error'
            className="p-1 border border-1"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitReport}
            variant="contained"
            className="menus-color"
          >
            {reportContent ? "Update Report" : "Submit Report"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default JournalTable;